import type { GetSfActivitiesRequest } from "@amzn/d16-g-client-deck-builder-typescript-client";
import type { AsyncState, UseAsyncActions } from "@react-hookz/web";
import { useAsync } from "@react-hookz/web";

import { getCdbApiClient } from "../../api/cdbApi/cdbApi";
import { useAsyncErrorStatusNotification } from "../notifications/useAsyncErrorStatusNotification";

export interface SfActivityActionProps {
    advertiserId: string;
    startDate: string;
    endDate: string;
}

export function useSfActivityAction({
    advertiserId,
    startDate,
    endDate,
}: SfActivityActionProps): [
    AsyncState<Record<string, string>[] | undefined>,
    UseAsyncActions<Record<string, string>[]>,
] {
    const request: GetSfActivitiesRequest = {
        advertiserId,
        startDate,
        endDate,
    };

    const [asyncSfActivityState, asyncSfActivityAction] = useAsync(async () => {
        const response = await (
            await getCdbApiClient()
        ).getSfActivities(request);

        return response.data ?? [];
    });

    useAsyncErrorStatusNotification(asyncSfActivityState);

    return [asyncSfActivityState, asyncSfActivityAction];
}
